export const SECTION_NAMES = {
  TOP_SECTION: 'topSection' as const,
  CARDS_SECTION: 'cardsSection' as const,
  CONTENT_SECTION_1: 'contentSection1' as const,
  CONTENT_SECTION_2: 'contentSection2' as const,
  CONTENT_SECTION_3: 'contentSection3' as const,
  CONTENT_SECTION_4: 'contentSection4' as const,
  CONTENT_SECTION_5: 'contentSection5' as const,
  CONTENT_SECTION_6: 'contentSection6' as const,
  CONTENT_SECTION_7: 'contentSection7' as const,
  FEED_SECTION: 'feedSection' as const,
  AUTHOR_SECTION: 'articles' as const,
};

export const SLOT_NAMES = {
  TOP_AD: 'topAd',
  ONE_ON_ONE: 'oneOnOne',
  IN_ARTICLE: 'inArticle',
  SIDE_BAR_1: 'sideBar1',
  SIDE_BAR_2: 'sideBar2',
};
